export enum RouteParamPlaceholder {
  Lang = ':lang',
  CrawlID = ':crawlID',
  GroupID = ':groupID',
  ProjectID = ':projectID',
  UrlID = ':urlID',
  LicenseID = ':licenseID',
}
